import { forwardRef } from 'react'
import classNames from 'classnames'
import { Icon } from '@winnin/ds-icon'

import type { SearchInputViewProps } from './search-input.types'

import './search-input.styles.scss'

export const SearchInputView = forwardRef<HTMLInputElement, SearchInputViewProps>(
  ({ type = 'search', className, ...props }, ref) => {
    return (
      <label className="SearchInput">
        <Icon name="search" width={20} height={20} className="SearchInput-icon" />
        <input ref={ref} type={type} className={classNames('SearchInput-input', className)} {...props} />
      </label>
    )
  }
)
